<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>

		<el-card class="box-card order-detail">
			<div slot="header" class="clearfix">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/member/order_list' }">订单列表</el-breadcrumb-item>
					<el-breadcrumb-item>订单详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div v-loading="loading">
				<template v-if="orderDetail">
					<div class="order-status">
						<h4>
							订单状态：
							<span class="ns-text-color">{{ orderDetail.order_status_name }}</span>
						</h4>
						<div v-if="orderDetail.order_status == 0" class="go-pay">
							<p>
								需付款：
								<span>￥{{ orderDetail.pay_money }}</span>
							</p>
						</div>

						<div class="operation" v-if="orderDetail.action.length > 0">
							<el-button type="primary" size="mini" plain v-if="orderDetail.is_evaluate == 1"
								@click="operation('memberOrderEvaluation')">
								<template v-if="orderDetail.evaluate_status == 0">
									评价
								</template>
								<template v-else-if="orderDetail.evaluate_status == 1">
									追评
								</template>
							</el-button>

							<el-button type="primary" size="mini"
								:plain="operationItem.action == 'orderPay' ? false : true"
								v-for="(operationItem, operationIndex) in orderDetail.action" :key="operationIndex"
								@click="operation(operationItem.action)">
								{{ operationItem.title }}
							</el-button>
						</div>
						<div class="operation"
							v-else-if="orderDetail.action.length == 0 && orderDetail.is_evaluate == 1">
							<el-button type="primary" size="mini" plain v-if="orderDetail.is_evaluate == 1"
								@click="operation('memberOrderEvaluation')">
								<template v-if="orderDetail.evaluate_status == 0">
									评价
								</template>
								<template v-else-if="orderDetail.evaluate_status == 1">
									追评
								</template>
							</el-button>
						</div>
						<div style="margin-top: 10px;">
							<el-button type="primary" size="mini" @click="exportSelect">下载清单</el-button>
						    <el-button type="primary" size="mini" v-print="printobj">打印订单</el-button>
						    <el-button type="primary" size="mini" @click="buyagain(orderDetail.order_id)">全部加入购物车</el-button>
						    <template v-if="$config.keFuUrl!=''">
								<el-button type="primary" size="mini" @click="jumpNotice">联系客服</el-button>
							</template>
						</div>
					</div>
				    <div  id="printSection">
						<div  class="dynysjcontent">
							<div class="order-info">
								<h4>订单信息</h4>
								<ul>
									<!-- <li>
									<i class="iconfont iconmendian"></i>
									店铺：
									<router-link :to="'/shop-' + orderDetail.site_id" target="_blank">{{ orderDetail.site_name }}</router-link>
								</li> -->
									<li>订单类型：{{ orderDetail.order_type_name }}</li>
									<li>订单编号：{{ orderDetail.order_no }}</li>
									<li>订单交易号：{{ orderDetail.out_trade_no }}</li>
									<li>配送方式：{{ orderDetail.delivery_type_name }}</li>
									<li v-if="orderDetail.order_status == -1">退款途径：{{ orderDetail.refund_money_type == 1 ?
										'原路退款' :
										orderDetail.refund_money_type == 2 ? '线下退款' : '退款到余额' }}</li>
									<li>创建时间：{{ $util.timeStampTurnTime(orderDetail.create_time) }}</li>
									<li v-if="orderDetail.close_time > 0">关闭时间：{{
										$util.timeStampTurnTime(orderDetail.close_time) }}</li>

								<li >原始金额：{{ orderDetail.goods_money }}</li>
								<li>余额支付：{{ orderDetail.balance_money }}</li>
								<li>优惠金额：{{discountsPice(orderDetail)}}</li>
								<li>应付金额：{{ orderDetail.pay_money }}</li>
								<li v-if="orderDetail.employeename">开票员：{{ orderDetail.employeename }}  {{orderDetail.employee_mobile || ''}}</li>
								<li  v-if="orderDetail.saler_info&&orderDetail.saler_info.fenxiao_name">业务员：{{ orderDetail.saler_info.fenxiao_name }}  {{orderDetail.saler_info.mobile || ''}}</li>
								<template v-if="orderDetail.pay_status > 0">
									<li>支付方式：{{ orderDetail.pay_type_name }}</li>
									<li>支付时间：{{ $util.timeStampTurnTime(orderDetail.pay_time) }}</li>
								</template>
								<li v-if="orderDetail.promotion_type_name != ''">店铺活动：{{ orderDetail.promotion_type_name }}</li>
								<li v-if="orderDetail.buyer_message != ''">买家留言：{{ orderDetail.buyer_message }}</li>
								</ul>
							</div>

							<div class="take-delivery-info">
								<h4>收货信息</h4>
								<ul>
									<li>收货人：{{ orderDetail.name }}</li>
									<li>手机号码：{{ orderDetail.mobile }}</li>
									<li>收货地址：{{ orderDetail.full_address }} {{ orderDetail.address }}</li>
								</ul>
							</div>

							<!-- 发票信息 -->
							<div class="take-delivery-info" v-if="orderDetail.is_invoice == 1">
								<h4>发票信息</h4>
								<ul>
									<li>发票类型：{{ orderDetail.invoice_type == 1 ? '纸质发票' : '电子发票' }}</li>
									<li>发票抬头类型：{{ orderDetail.invoice_title_type == 1 ? '个人' : '企业' }}</li>
									<li>发票抬头：{{ orderDetail.invoice_title }}</li>
									<li>发票内容：{{ orderDetail.invoice_content }}</li>
									<li v-if="orderDetail.invoice_type == 1">发票邮寄地址地址：{{ orderDetail.invoice_full_address }}
									</li>
									<li v-else>发票接收邮箱：{{ orderDetail.invoice_email }}</li>
								</ul>
							</div>

		
						<nav class="nav">
							<li>排序</li>
							<li :class="{ 'no-operation': !orderDetail.is_enable_refund }">商品信息</li>
							<li>经营类型</li>
							<li>单价</li>
							<li>购买数量</li>
							<li>未出库数量</li>
							<li>小计</li>
							<li>操作</li>
						</nav>

							<!-- 订单项·商品 -->
							<div class="list">
								<template v-for="(goodsItem, goodsIndex) in orderDetail.order_goods">
									<template v-if="goodsExpand || goodsIndex < showGoodsLimit">
										<ul class="item">
											<li>{{goodsIndex+1}}</li>
											<li :class="[{ 'no-operation': !orderDetail.is_enable_refund },'goods_infoBox']">
												<goods-image :goods="goodsItem" :imageSize="70" :showLable="true"></goods-image>
												<div class="info-wrap">
													<h5 @click="$router.pushToTab('/sku-' + goodsItem.sku_id)">
														{{ goodsItem.sku_name }}
														<span style="color: #ff547b;font-size: 12px;" v-if="goodsItem.goods_size !=''">({{ goodsItem.goods_size }})</span>
													</h5>
													<ctrlShowText :info="goodsItem" type="custom" size="12px" gap="10px" color="#9a9a9a"
													:wesArr="['规格','效期','厂家']" :traArr="['规格','生产日期','厂家']" :expandArr="['税率','ERPID']"></ctrlShowText>
												</div>
											</li>
											<li>
											<span>{{goodsItem.business_scope_name}}</span>
											</li>
											<li :style="returnShowMoreInfo(goodsItem)">
												<template v-if="(goodsItem.promotion_type_name.includes('秒杀') || goodsItem.promotion_type_name.includes('折扣')|| goodsItem.promotion_label==='wholesale') && goodsItem.discount_goods_limit>0&& goodsItem.num > goodsItem.discount_goods_limit">
													<span>￥{{ goodsItem.original_price }} x{{ goodsItem.num - goodsItem.discount_goods_limit }}</span>
													<span style="margin-bottom: 78px;">￥{{ goodsItem.price }} x{{ goodsItem.discount_goods_limit }}</span>
												</template>
												<template v-else>
													<template v-if="goodsPrice(goodsItem).real_price > 0">
														<div class="price_new">
															<div class="class_1">
																<span>￥</span>
																<span>{{ goodsPrice(goodsItem).real_price }}</span>
																<span v-if="goodsItem.unit">/{{ goodsItem.unit }}</span>
															</div>
															<div class="class_2" v-if="goodsPrice(goodsItem).original_price>0">
																<span>￥</span>
																<span>{{ goodsPrice(goodsItem).original_price }}</span>
																<span v-if="goodsItem.unit">/{{ goodsItem.unit }}</span>
															</div>
														</div>
													</template>
													<template v-else>
														<span>￥{{ goodsItem.price }}</span>
													</template>
												</template>
											</li>
											<li>
												<span>{{ goodsItem.num }}</span>
											</li>
											<li>
												<span>{{goodsItem.num - goodsItem.issue_num}}</span>
											</li>
											<li>
												<template v-if="goodsPrice(goodsItem).original_price>0">
													<div class="price_new_2">
														<div class="class_1">
															<span>￥</span>
															<span>{{ goodsPrice(goodsItem).total_real_price }}</span>
														</div>
														<div class="class_2">
															<div>
																<span>￥</span>
																<span>{{ goodsPrice(goodsItem).total_original_price }}</span>
															</div>
															<div v-if="goodsPrice(goodsItem).total_discount_price>0">
																<span>优惠</span>
																<span>￥</span>
																<span>{{ goodsPrice(goodsItem).total_discount_price }}</span>
															</div>
														</div>
													</div>
												</template>
												<template v-else>
													<span>￥{{ (goodsItem.price * goodsItem.num).toFixed(2) }}</span>
												</template>
											</li>
											<li class="buttonBox">
												<template v-if="orderDetail.is_enable_refund&&orderDetail.pay_type!='POINT'">
													<template v-if="allowRefund">
														<el-button type="primary" plain size="mini" v-if="goodsItem.refund_status == 0"
															@click="$router.push({ path: '/member/refund', query: { order_goods_id: goodsItem.order_goods_id, order_id: orderId } })">
															退款
														</el-button>
														<el-button type="primary" plain size="mini" v-else
															@click="$router.push({ path: '/member/refund_detail', query: { order_goods_id: goodsItem.order_goods_id } })">
															查看退款
														</el-button>
													</template>
													<el-button v-if="orderDetail.order_status != 0" type="primary" size="mini" @click="openGoodsInfo(goodsItem.goods_id)">药品资质</el-button>
												</template>
												<el-badge style="display: flex;" :value="returnGoodsCartNum(goodsItem)||''">
													<el-button type="primary" size="mini" @click="goodsJoinCartFun(goodsItem)">
														加入购物车
													</el-button>
												</el-badge>
											</li>
										</ul>
									</template>
								</template>
								<template v-if=" orderDetail.order_goods && orderDetail.order_goods.length>showGoodsLimit">
									<div class="moreGoodsTip" @click="goodsExpandFun">
										<span>{{ goodsExpand?'收起更多商品':'查看全部商品' }}</span>
										<span :class="[goodsExpand?'el-icon-arrow-up':'el-icon-arrow-down']"></span>
									</div>
								</template>
							</div>

							<!-- 订单总计 -->
							<ul class="total">
								<li>
									<label>商品金额：</label>
									<span>￥{{ orderDetail.goods_money }}</span>
								</li>
								<li>
									<label>优惠金额：</label>
									<span>￥{{ (parseFloat(orderDetail.coupon_money) + parseFloat(orderDetail.promotion_money)).toFixed(2) }}</span>
								</li>
								<!-- <li v-if="orderDetail.coupon_money">
									<label>优惠劵：</label>
									<span>
									￥{{orderDetail.coupon_money}}</span> 
								</li>
								<li  v-if="orderDetail.coupon_money">
									<label>满减优惠：</label>
									<span >
									￥{{orderDetail.promotion_money}}</span> 
								</li>  -->
								<li>
									<label>运费：</label>
									<span>￥{{ orderDetail.delivery_money }}</span>
								</li>
								<li v-if="orderDetail.member_card_money > 0">
									<label>客户卡：</label>
									<span>￥{{ orderDetail.member_card_money }}</span>
								</li>
								<li v-if="orderDetail.invoice_money > 0">
									<label>税费：</label>
									<span>￥{{ orderDetail.invoice_money }}</span>
								</li>
								<li v-if="orderDetail.invoice_delivery_money > 0">
									<label>发票邮寄费：</label>
									<span>￥{{ orderDetail.invoice_delivery_money }}</span>
								</li>
								<li v-if="orderDetail.adjust_money != 0">
									<label>订单调整：</label>
									<span>
										<template v-if="orderDetail.adjust_money < 0">
											-
										</template>
										<template v-else>
											+
										</template>
										￥{{ orderDetail.adjust_money | abs }}
									</span>
								</li>
								<li v-if="orderDetail.point_money > 0">
									<label>积分抵扣：</label>
									<span>￥{{ orderDetail.point_money }}</span>
								</li>
								<li v-if="orderDetail.balance_money > 0">
									<label>使用余额：</label>
									<span>￥{{ orderDetail.balance_money }}</span>
								</li>
								<!-- <li> 
									<label>邮费：</label>
									<span  v-if="orderDetail.coupon_money">￥{{orderDetail.delivery_money}}</span></li> -->
								<li class="pay-money">
									<label>实付款：</label>
									<span>￥{{ orderDetail.pay_money }}</span>
								</li>
							</ul>
					</div>
					</div>
				</template>
			</div>
		</el-card>
		<el-dialog title="药品资质" v-loading="goods_info_loading" :visible.sync="goods_info_state" width="30%" center top="300px">
			<div class="goods_info_filter" v-if="goods_info_arr.length>0">
				<el-radio-group v-model="filterType" size="small">
					<el-radio-button label="all">全部</el-radio-button>
					<el-radio-button label="product">产品资料</el-radio-button>
					<el-radio-button label="inspection">检验报告</el-radio-button>
				</el-radio-group>
			</div>
			<div class="goods_info_box" v-if="goods_info_arr.length>0">
				<template v-for="item in filteredGoodsInfo">
					<div class="goods_info_item">
						<div>
							<span class="el-icon-document"></span>
							<span>{{ item.name }}</span>
						</div>
						<div @click="seeGoodsInfo(item)">
							<span>查看</span>
							<span class="el-icon-arrow-right"></span>
						</div>
					</div>
				</template>
				<div v-if="filteredGoodsInfo.length === 0" class="no-data">暂无相关资质文件</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as XLSX from "xlsx";
import { cartList } from "@/api/goods/cart"
import {
	apiOrderDetail,
	apibuyagain,getGoodsInfoById
} from '@/api/order/order';
import orderMethod from '@/utils/orderMethod';
import {
	mapGetters
} from 'vuex';
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
import goodsImage from "@/components/goods-image/goods-image.vue";
export default {
	name: 'order_detail',
	components: {ctrlShowText,goodsImage},
	mixins: [orderMethod],
	data: () => {
		return {
			orderId: 0,
			orderDetail: null,
			loading: true,
			yes: true,
			goods_info_state:false,
			goods_info_loading:false,
			goods_info_arr:[],
			filterType: 'all', // 筛选类型：all-全部, product-产品资料, inspection-检验报告
			printobj: {
				id: "#printSection",
				popTitle: '订单信息',
			},
			ifJumpPay:false,
			cartListArr:[],
			goodsJoinCartTimer:null,
			showGoodsLimit:50,
			goodsExpand:false,
			allowRefund:false,
		};
	},
	created() {
		this.orderId = this.$route.query.order_id;
		this.getOrderDetail();
		this.getCartList();
	},
	mounted() {
		let self = this;
		setTimeout(function () {
			self.yes = false
		}, 300)
	},
	computed: {
		...mapGetters(['defaultGoodsImage']),
		// 筛选后的资质文件列表
		filteredGoodsInfo() {
			if (this.filterType === 'all') {
				return this.goods_info_arr;
			}
			return this.goods_info_arr.filter(item => item.type === this.filterType);
		}
	},
	methods: {
		goodsPrice(goodsItem) {
            const { num, real_price, price, discount_price, original_price } = goodsItem;
            const qty = Number(num);
            const realPrice = Number(real_price);
            const currentPrice = Number(price);
            const discountPrice = Number(discount_price);
            const originalPrice = Number(original_price);

            // 确定用于比较的价格（划线价的候选值）
            let comparePrice = null;
            if (realPrice !== currentPrice) {
				comparePrice = currentPrice;
			}

            // 最终划线价：仅当实际价格低于比较价格时才设置
            const finalOriginalPrice = (comparePrice !== null && realPrice < comparePrice) ? comparePrice : 0;

            const totalReal = realPrice * qty;
            const totalOriginal = finalOriginalPrice * qty;
            const totalDiscount = (totalOriginal > 0 && totalReal > 0) ? totalOriginal - totalReal : 0;

            // 保留两位小数
            const round2 = (num) => Number(num.toFixed(2));
			let Obj = {
                real_price: round2(realPrice),
                total_real_price: round2(totalReal),
                original_price: round2(finalOriginalPrice),
                total_original_price: round2(totalOriginal),
                total_discount_price: round2(totalDiscount),
            };
            return Obj;
        },
		jumpNotice() {
			KeFu.toggle_window('show');
			let if_first_load = localStorage.getItem('if_first_load');
			let timeNum = if_first_load!=='1'? 2000 : 1000;
			setTimeout(() => {
				// search 是订单号
				KeFu.sendMessage(`订单编号：${this.orderDetail.order_no}`,0);
				// 发送订单链接
				setTimeout(() => {
					let link = `${this.$config.baseUrl}shop/order/lists.html#!order_label=order_no&search=${this.orderDetail.order_no}`;
				    let title = '点击查看订单详情';
				    KeFu.sendLink(link, title);
				},200);
			}, timeNum);
		},
		returnShowMoreInfo(goodsItem){
            let bool = ((goodsItem.promotion_type_name.includes('秒杀') || goodsItem.promotion_type_name.includes('折扣')|| goodsItem.promotion_label==='wholesale') && goodsItem.discount_goods_limit>0&& goodsItem.num > goodsItem.discount_goods_limit);
            if(bool){
                return 'display: flex;flex-direction: column;line-height: 20px;padding-top: 30px;box-sizing: border-box;'
            }
            return '';
        },
		discountsPice(orderDetail){
			console.log(typeof(orderDetail.pay_money));
			
			console.log((Number(orderDetail.goods_money) + Number( orderDetail.delivery_money) ) - Number(orderDetail.pay_money));
			
		let  discounts= (Number(orderDetail.goods_money) + Number( orderDetail.delivery_money) ) - Number(orderDetail.pay_money)
			return  discounts.toFixed(2)
		},
		buyagain(id) {
            apibuyagain({
				order_id:id
			})
                .then(res => { 
				 if(res.code>=0){
					this.$router.push('/cart')
				 }
				})
                .catch(err => {
					console.log(err)
				})
        },
		exportSelect() {
			//  导出选中
			this.$confirm("是否确认导出当前订单商品列表?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then((response) => {
				//  this.selectdata 是复选框的 数据列表
				if (this.orderDetail.order_goods <= 0) {
					this.$message.info('暂无商品信息！');
					return false;
				};
				let tempArr = this.orderDetail.order_goods.map(item => {
					if(!item.attr && item.goods_attr){
						let attr = JSON.parse(item.goods_attr);
						item.attr = attr;
					}
					return item;
				});
				let bool = tempArr.some(item => item.attr?.attr_batch_number || item.goods_attr_format?.attr_batch_number);
				let tableData = [
					['序号', "ERPID", '商品名称', '产地','厂家', '规格', '效期','生产日期',  "单价", "数量", "小计"]
				];
				if(bool){
					tableData[0].splice(7, 0, '产品批号');
				};
				tempArr.forEach((item, index) => {
					let rowData = []
					let price = (Number(item.real_goods_money)/Number(item.num)).toFixed(3);
					//导出内容的字段
					rowData = [
						index + 1,
						item.goods_erp_spid,
						item.goods_name,
						item.goods_attr_format?.attr_place || item.attr?.attr_place || '无',
						item.goods_attr_format?.attr_factory || item.attr?.attr_factory || '无',
						item.goods_attr_format?.attr_specs || item.attr?.attr_specs || '无',
						item.goods_attr_format?.attr_validity || item.attr?.attr_validity || '无',
                        item.goods_attr_format?.attr_production_date || item.attr?.attr_production_date || '无',
                        parseFloat(price),
                        parseInt(item.num),
                        parseFloat(item.real_goods_money)
					]
					if(bool){
						rowData.splice(7, 0, item.attr.attr_batch_number);
					}
					tableData.push(rowData)
				});
				let workSheet = XLSX.utils.aoa_to_sheet(tableData);
				workSheet['!cols'] = [
					{ wch: 6 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 30 },
					{ wch: 30 },
					{ wch: 30 },
					{ wch: 14 },
					{ wch: 14 },
					{ wch: 10 },
					{ wch: 10 },
					{ wch: 10 }
				]
				if(bool){
					workSheet['!cols'].splice(7, 0, { wch: 20 });
				}
				let bookNew = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(bookNew, workSheet, '') // 工作簿名称
				let name = '商品清单' + this.timeFormat() + '.xlsx'
				XLSX.writeFile(bookNew, name) // 保存的文件名
			})
		},
		timeFormat() {
			let time = new Date();
			let year = time.getFullYear();
			let month = time.getMonth() + 1;
			let date = time.getDate();
			let hours = time.getHours();
			let minutes = time.getMinutes();
			let seconds = time.getSeconds();
			return year + '-' + this.addZero(month) + '-' + this.addZero(date) + ' ' + this.addZero(hours) + ':' + this.addZero(minutes) + ':' + this.addZero(seconds);
		},
		addZero(num) {
			return num < 10 ? '0' + num : num
		},
		getOrderDetail() {
			apiOrderDetail({
				order_id: this.orderId
			})
				.then(res => {
					if (res.code >= 0) {
						this.orderDetail = res.data;
						if(this.orderDetail.order_goods.length>0){
							this.orderDetail.order_goods = this.orderDetail.order_goods.map((item)=>{
								if(item.goods_attr){
									let attr = JSON.parse(item.goods_attr);
									let { goods_size } = attr;
									item.goods_size = goods_size || '';
								}
								return item;
							});
						};
						this.loading = false;
					} else {
						this.$message({
							message: '未获取到订单信息',
							type: 'warning',
							duration: 2000,
							onClose: () => {
								this.$router.push({
									path: '/member/order_list'
								});
							}
						});
					}
				})
				.catch(err => {
					this.loading = false;
					this.$message.error({
						message: err.message,
						duration: 2000,
						onClose: () => {
							this.$router.push({
								path: '/member/order_list'
							});
						}
					});
				});
		},
		operation(action) {
			switch (action) {
				case 'orderPay': // 支付
				    if(this.ifJumpPay)return;
					this.ifJumpPay = true;
					let { out_trade_no } = this.orderDetail;
					if(out_trade_no){
						this.$router.push({ path: "/pay", query: { code: out_trade_no }  })
					}else{
						this.$message({
							message: '订单未生成支付订单号',
							type: 'warning',
							duration: 2000,
						});
					}
					setTimeout(()=>{
						this.ifJumpPay = false;
					},2000)
					break;
				case 'orderClose': //关闭
					this.orderClose(this.orderDetail.order_id, () => {
						this.getOrderDetail();
					});
					break;
				case 'memberTakeDelivery': //收货
					this.orderDelivery(this.orderDetail.order_id, () => {
						this.getOrderDetail();
					});
					break;
				case 'trace': //查看物流
					this.$router.push({
						path: '/member/logistics',
						query: {
							order_id: this.orderDetail.order_id
						}
					});
					break;
				case 'memberOrderEvaluation': //评价
					this.$router.pushToTab({
						path: '/evaluate',
						query: {
							order_id: this.orderDetail.order_id
						}
					});
					break;
			}
		},
		imageError(index) {
			this.orderDetail.order_goods[index].sku_image = this.defaultGoodsImage;
		},
		openGoodsInfo(id){
			this.goods_info_state = true;
			this.goods_info_loading = true;
			this.filterType = 'all'; // 重置筛选条件
			getGoodsInfoById({
				goods_id:id
			}).then(res=>{
				this.goods_info_arr = [];
				// product_data 产品资料  inspection_data 检验报告
				if(res.inspection_data!=null){
					// 添加类型标识
					const inspectionList = res.inspection_data.map(item => ({
						...item,
						type: 'inspection'
					}));
					this.goods_info_arr = this.goods_info_arr.concat(inspectionList);
				}
				if(res.product_data!=null){
					// 添加类型标识
					const productList = res.product_data.map(item => ({
						...item,
						type: 'product'
					}));
					this.goods_info_arr = this.goods_info_arr.concat(productList);
				}
				this.goods_info_loading = false;
				
			})
		},
		seeGoodsInfo(info){
			window.open(info.path,'_blank', 'width=800,height=600,top=100,left=100,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes');
		},
		goodsExpandFun(){
			this.goodsExpand = !this.goodsExpand;
		},
		getCartList(){
			cartList({}).then(res => {
				if (res.code >= 0) {
					this.cartListArr = [...res.data,...res.bundling];
				}
			})
			.catch(res => {})
		},
		returnGoodsCartNum(goodsItem){
			let cartNum = 0;
			if(this.cartListArr.length>0){
				this.cartListArr.forEach(v => {
					if (v.sku_id == goodsItem.sku_id) {
						cartNum = v.num;
					}
				});
			}
			return cartNum;
		},
		goodsJoinCartFun(goodsItem){
			if(this.goodsJoinCartTimer!=null){
				return
			}
			this.goodsJoinCartTimer = setTimeout(()=>{
				clearTimeout(this.goodsJoinCartTimer);
				this.goodsJoinCartTimer = null;
			},1000)
			const cartData = {
				site_id: goodsItem.site_id,
				num: goodsItem.num,
				sku_id: goodsItem.sku_id,
			};
			this.$store.dispatch("cart/add_to_cart", cartData).then((res)=>{
				if (res.code === 0) {
					this.$message({
						message: "加入购物车成功",
						type: "success"
					})
					this.getCartList();
				}else{
					this.$message.error(res.message);
				}
			}).catch(err=>{
				this.$message.error(err.message);
			})
		}
	},
	filters: {
		abs(value) {
			return Math.abs(parseFloat(value)).toFixed(2);
		}
	}
};
</script>
<style lang="scss" >
@media print { 
  .dynysjcontent {
		 nav{
		overflow: hidden;
		padding: 10px 0;
		background: #fff;
		border-bottom: 1px solid #eeeeee;

		li {
			float: left;

			&:nth-child(1) {
				width: 5%;
			}

			&:nth-child(2) {
				width: 30%;
				&.no-operation {
					width: 30%;
				}
			}

			&:nth-child(3) {
				width: 10%;
			}

			&:nth-child(4) {
				width: 15%;
			}

			&:nth-child(5) {
				width: 10%;
			}
		}
		 }
  }
  .list {
		display: flex;
		flex-direction: column;
		border-bottom: 1px solid #eeeeee;

		.item {
			background-color: #fff;
			padding: 10px 0;

			li {
				float: left;
				line-height: 100px;

				&:nth-child(1) {
					width: 5%;
				}

				&:nth-child(2) {
					width: 30%;
					line-height: inherit;

&.no-operation {
	width: 30%;
	display: flex;
	align-items: center;
}

.img-wrap {
	cursor: pointer;

	img {
		width: 60px;
		height: 60px;
	}
}

.info-wrap {
	margin-left: 10px;

	h5 {
		font-weight: normal;
		font-size: $ns-font-size-base;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		overflow: hidden;
		margin-right: 10px;
		display: inline-block;
		cursor: pointer;

		&:hover {
			color: $base-color;
		}
	}

	span {
		font-size: $ns-font-size-sm;
		color: #9a9a9a;
	}
}
				}

				&:nth-child(3) {
					width: 10%;
				}

				&:nth-child(4) {
					width: 15%;
				}

				&:nth-child(5) {
					width: 10%;
				}
			}
		}
		.order-status {
		background-color: #fff;
		margin-bottom: 20px;

		h4 {
			margin: 10px 0 20px;
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 10px;
		}

		.go-pay {
			p {
				display: inline-block;
				vertical-align: middle;

				span {
					font-weight: bold;
					color: $base-color;
					font-size: 18px;
				}
			}
		}

		.operation {
			margin-top: 10px;
		}
	}
	}
	.total {
		padding: 20px;
		background-color: #fff;
		text-align: right;

		li {
			span {
				width: 150px;
				display: inline-block;
			}

			&.pay-money {
				font-weight: bold;

				span {
					color: $base-color;
					font-size: 16px;
					vertical-align: middle;
				}
			}
		}
	}
	.order-info {
		background-color: #fff;
		margin-bottom: 10px;

		h4 {
			margin: 10px 0 20px;
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 10px;
		}

		ul {
			display: flex;
			flex-wrap: wrap;
			li {
				flex: 0 0 35.5%;
				margin-bottom: 10px;

				&:last-child {
					flex: initial;
				}
				&:nth-child(3) {
				  width: 10%;
			}

			}
			
		}
	}

}
.box {
	width: 100%;
	position: relative;
}

.null-page {
	width: 100%;
	height: 730px;
	background-color: #FFFFFF;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
}

.order-detail {
	.order-status {
		background-color: #fff;
		margin-bottom: 20px;

		h4 {
			margin: 10px 0 20px;
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 10px;
		}

		.go-pay {
			p {
				display: inline-block;
				vertical-align: middle;

				span {
					font-weight: bold;
					color: $base-color;
					font-size: 18px;
				}
			}
		}

		.operation {
			margin-top: 10px;
		}
	}

	.order-info {
		background-color: #fff;
		margin-bottom: 10px;

		h4 {
			margin: 10px 0 20px;
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 10px;
		}

		ul {
			display: flex;
			flex-wrap: wrap;

			li {
				flex: 0 0 33.3333%;
				margin-bottom: 10px;

				&:last-child {
					flex: initial;
				}
			}
		}
	}

	.take-delivery-info {
		background-color: #fff;
		margin-bottom: 10px;

		h4 {
			margin: 10px 0 20px;
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 10px;
		}

		ul {
			display: flex;
			flex-wrap: wrap;

			li {
				flex: 0 0 33.3333%;
				margin-bottom: 10px;

				&:last-child {
					flex: initial;
				}
			}
		}
	}

	nav {
		overflow: hidden;
		padding: 10px 0;
		background: #fff;
		border-bottom: 1px solid #eeeeee;

		li {
			float: left;

			&:nth-child(1) {
				width: 5%;
			}

			&:nth-child(2) {
				width: 30%;
				&.no-operation {
					width: 30%;
				}
			}

			&:nth-child(3) {
				width: 10%;
			}

			&:nth-child(4) {
				width: 10%;
			}

			&:nth-child(5) {
				width: 10%;
			}
			&:nth-child(6) {
				width: 15%;
			}
			&:nth-child(7) {
				width: 10%;
			}
		}
	}

	.list {
		border-bottom: 1px solid #eeeeee;
		display: flex;
		flex-direction: column;
		.item {
			background-color: #fff;
			padding: 10px 0;

			li {
				float: left;
				line-height: 100px;

				&:nth-child(1) {
					width: 5%;
	
				}

				&:nth-child(2) {
					width: 30%;
					line-height: inherit;

&.no-operation {
	width: 30%;
	display: flex;
	align-items: center;
}

.img-wrap {
	cursor: pointer;

	img {
		width: 60px;
		height: 60px;
	}
}

.info-wrap {
	margin-left: 10px;

	h5 {
		font-weight: normal;
		font-size: $ns-font-size-base;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		overflow: hidden;
		margin-right: 10px;
		display: inline-block;
		cursor: pointer;

		&:hover {
			color: $base-color;
		}
	}

	span {
		font-size: $ns-font-size-sm;
		color: #9a9a9a;
	}
}
				}

				&:nth-child(3) {
					width: 10%;
					span{
						display: inline-block;
					}
				}

				&:nth-child(4) {
					width: 10%;
				}

				&:nth-child(5) {
					width: 10%;
				}
				&:nth-child(6) {
					width: 15%;
				}
				&:nth-child(7) {
					width: 10%;
				}
			}
		}
	}

	// 总计
	.total {
		padding: 20px;
		background-color: #fff;
		text-align: right;

		li {
			span {
				width: 150px;
				display: inline-block;
			}

			&.pay-money {
				font-weight: bold;

				span {
					color: $base-color;
					font-size: 16px;
					vertical-align: middle;
				}
			}
		}
	}
}
.goods_infoBox{
   display: flex;
   >div:nth-child(1){
	flex-shrink: 0;
   }
   >div:nth-child(2){
	width: calc(100% - 80px);
   }
}
.goods_info_box{
	display: flex;
	flex-direction: column;
	gap: 12px;
	height: 300px;
	overflow-y: auto;
	.goods_info_item{
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #f5f5f5;
		border-radius: 6px;
		padding: 12px;
		box-sizing: border-box;
		>div{
			display: flex;
			align-items: center;
			gap: 6px;
			>span{
				font-size: 16px;
			}
		}
		>div:nth-child(2){
			width: 55px;
			flex-shrink: 0;
			margin-left: 12px;
			cursor: pointer;
		}
	}
	.no-data{
		text-align: center;
		padding: 40px 0;
		color: #999;
		font-size: 14px;
	}
}
.goods_info_filter{
	margin-bottom: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid #ebeef5;
}
.buttonBox{
	display: flex;
	flex-direction: column;
	gap: 4px;
	>.el-button{
		margin: 0;
	}
}
.moreGoodsTip{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	background-color: #f5f5f5;
	cursor: pointer;
	>span{
		color: #31bb6d;
		font-size: 18px;
	}
}
.price_new{
	display: flex;
	flex-direction: column;
	gap: 6px;
	height: 100px;
	justify-content: center;
	
	div{
		line-height: 1;
		span{
			line-height: 1;
		}
	}
	.class_1{
		display: flex;
		align-items: baseline;
		>span:nth-child(1){
			font-size: 12px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(2){
			font-size: 14px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(3){
			font-size: 12px;
			color: #999;
		}
	}
	.class_2{
		display: flex;
		align-items: baseline;
		>span:nth-child(1){
			font-size: 12px;
			color: #999;
			font-weight: bold;
			text-decoration: line-through 1px;
		}
		>span:nth-child(2){
			font-size: 14px;
			color: #999;
			font-weight: bold;
			text-decoration: line-through 1px;
		}
		>span:nth-child(3){
			font-size: 12px;
			color: #999;
		}
	}
}
.price_new_2{
	display: flex;
	flex-direction: column;
	gap: 6px;
	height: 100px;
	justify-content: center;
	
	div{
		line-height: 1;
		span{
			line-height: 1;
		}
	}
	.class_1{
		display: flex;
		align-items: baseline;
		>span:nth-child(1){
			font-size: 12px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(2){
			font-size: 14px;
			color: #333;
			font-weight: bold;
		}
		>span:nth-child(3){
			font-size: 12px;
			color: #999;
		}
	}
	.class_2{
		display: flex;
		flex-direction: column;
		gap: 6px;
		>div:nth-child(2){
			display: flex;
			align-items: center;
			>span{
				color: red;
                font-weight: bold;
			}
		}
		>div:nth-child(1){
			display: flex;
			align-items: baseline;
			>span:nth-child(1){
				font-size: 12px;
				color: #999;
				font-weight: bold;
				text-decoration: line-through 1px;
			}
			>span:nth-child(2){
				font-size: 14px;
				color: #999;
				font-weight: bold;
				text-decoration: line-through 1px;
			}
			>span:nth-child(3){
				font-size: 12px;
				color: #999;
			}
		}
	}
}
</style>
